var React = require('react');

function WarningTriangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 21H0L12 1L24 21ZM11 8H13V14H11V8ZM13 16H11V18H13V16Z","fill":"#343A40"}));
}

WarningTriangle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"#E56C6C"};

module.exports = WarningTriangle;

WarningTriangle.default = WarningTriangle;
